import React, { useContext  } from 'react';
import '../../styles/HomeComponents/HeroSection.css';
import dashboardImage from '../../assets/Images/Group219.webp';
import { AuthContext } from '../../context/authContext';
import { Helmet } from 'react-helmet-async';


const HeroSection = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const SITE_URL = process.env.REACT_APP_SITE_URL;
  console.log(SITE_URL);

  const handleClick = () => {
  const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL;

  try {
    // OPEN TIDYCAL IN SAME TAB ← REQUIRED FOR REDIRECT TO WORK
    window.location.href = tidycalUrl;
  } catch (error) {
    console.error('Error opening TidyCal booking page:', error);
    alert('An error occurred while trying to open the booking page. Please try again later.');
  }
};


  
  return (
    <section className="hero-container">

<Helmet>
<link
    rel="preload"
    as="image"
    href={dashboardImage}
    type="image/webp"
  />
</Helmet>
     
      <div className="hero-text">
        <h1>
          Strawket – Connecting <span className="highlight">learners</span> with the right teachers
        </h1>
        <p>
          <span className='gray'>
            Strawket makes it simple to follow your passion. As a learner, discover expert-led activities or track
            progress easily
          </span>; As a teacher or administrator, manage your academy effortlessly.
        </p>
        <div className="hero-buttons">
            <a 
      href={`${SITE_URL}/academies`}
      className="login-btn4"
    >
      Academy
    </a>
          
          <button onClick={handleClick} className="demo-btn2">
     Free Demo
    </button>
        </div>
      </div>

      <div className="hero-images">
      <img
  src={dashboardImage}
  alt="Strawket Dashboard Preview"
   width="1456" // or exact dimensions of your image
  height="995"
  loading="eager"
  fetchpriority="high"
  decoding="async"
  style={{ width: '100%', height: 'auto' }}
/>

      </div>
    </section>
  );
};

export default HeroSection;
